import { useGetFormData } from 'cng-common/features/form'

import { PartnerEditorFormKeys } from '../configs'

export const useHasChanges = () => {
  const [{ modifiedFields: basicModifiedValues }] = useGetFormData(PartnerEditorFormKeys.BasicInfo)
  const [{ modifiedFields: legalModifiedValues }] = useGetFormData(PartnerEditorFormKeys.LegalInfo)
  const [{ modifiedFields: additionalModifiedValues }] = useGetFormData(
    PartnerEditorFormKeys.AdditionalInfo
  )

  return basicModifiedValues.length || legalModifiedValues.length || additionalModifiedValues.length
}
